//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shopName:'',
      initShopArea:'全部',
      shopAreaList:[
        {value: '全部',label: '全部'}, 
        {value: '锦江',label: '锦江'}, 
        {value: '青羊',label: '青羊'}, 
        {value: '金牛',label: '金牛'}, 
        {value: '武侯',label: '武侯'}, 
        {value: '成华',label: '成华'}, 
        {value: '龙泉驿',label: '龙泉驿'}, 
        {value: '青白江',label: '青白江'}, 
        {value: '新都',label: '新都'},
        {value: '温江',label: '温江'}, 
        {value: '双流',label: '双流'}, 
        {value: '邯郸区',label: '邯郸区'}, 
        {value: '简阳',label: '简阳'}, 
        {value: '都江堰',label: '都江堰'}, 
        {value: '彭州',label: '彭州'}, 
        {value: '邛崃',label: '邛崃'}, 
        {value: '崇州',label: '崇州'}, 
        {value: '金堂',label: '金堂'}, 
        {value: '大邑',label: '大邑'}, 
        {value: '浦江',label: '浦江'}, 
        {value: '新津',label: '新津'}, 
        {value: '高新区',label: '高新区'}, 
        {value: '天府新区',label: '天府新区'}, 
        {value: '高新西区',label: '高新西区'}
      ],
      pageSizeValue:10,
      total:0,
      pageNo:1,
      tableData:[],
      bayList:[
        {value:'-1',label:'全部'},
        {value:'0',label:'未采购'},
        {value:'1',label:'电商用户'},
        {value:'2',label:'云库存用户'},
      ],
      bayValue:'-1',
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        shopStatus:this.bayValue,
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
      }
      if(this.shopName !== ''){
        data.shopName = this.shopName
      }
      if(this.initShopArea !== '全部'){
        data.shopArea = this.initShopArea
      }
      this.$axios.post('/mtea/stock/shopping/list', data).then(res => {
        this.tableData = res.records
        this.total = res.total
      }).catch((err)=>{
        console.log(err)
        // this.tableData = []
        // this.total = 0
        // this.pageSize = 0
      })
    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      return style
    },
    rowStyle(){
      return {'font-size':'12px'}
    },
    // lookClick(row){
    //   console.log(row)
    // },
    handleClick(row){
      console.log(row)
      this.$router.push({'name':'msg',query:{shopId:row.shopId}})
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
  },
}
